<template>
  <div>
    <p
      :class="ClassObject"
      style="cursor: pointer"
      @click="onClicked(column, row)"
      plain
    >
      {{ rowValue }} <span v-if="Months.includes(column.property)">%</span>
    </p>
  </div>
</template>

<script>
export default {
  name: "LinkdialogOpener",
  props: {
    rowValue: {
      type: Number,
      default: 0,
      required: true
    },
    row: {
      type: Object,
      default: () => ({}),
      required: true
    },
    column: {
      type: Object,
      default: () => ({}),
      required: true
    },
    call: {
      type: Function,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      Months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ]
    };
  },
  computed: {
    ClassObject() {
      let isred = false;
      let isyellow = false;
      let isgreen = false;
      if (this.Months.includes(this.column.property)) {
        if (this.rowValue < 80) {
          isred = true;
          isyellow = false;
          isgreen = false;
        } else if (this.rowValue >= 80 && this.rowValue < 90) {
          isyellow = true;
          isred = false;
          isgreen = false;
        } else if (this.rowValue >= 90) {
          isgreen = true;
          isred = false;
          isyellow = false;
        } else {
          isred = false;
          isyellow = false;
          isgreen = false;
        }
      } else {
        isred = false;
        isyellow = false;
        isgreen = false;
      }

      let classOject = {
        red: isred,
        yellow: isyellow,
        green: isgreen
      };

      return classOject;
    }
  },
  methods: {
    onClicked(column, row) {
      this.call(column, row);
    }
  }
};
</script>

<style lang="css">
.red {
  color: red;
}
.yellow {
  color: orange;
}
.green {
  color: green;
}
</style>
